export default "__VITE_ASSET__D4aj7Meh__"